// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRenewalPayrollGroupReducedDto
 */
export interface IRenewalPayrollGroupReducedDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollGroupReducedDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollGroupReducedDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollGroupReducedDto
     */
    code?: string;
}

/**
 * Check if a given object implements the IRenewalPayrollGroupReducedDto interface.
 */
export function instanceOfIRenewalPayrollGroupReducedDto(value: object): value is IRenewalPayrollGroupReducedDto {
    return true;
}

export function IRenewalPayrollGroupReducedDtoFromJSON(json: any): IRenewalPayrollGroupReducedDto {
    return IRenewalPayrollGroupReducedDtoFromJSONTyped(json, false);
}

export function IRenewalPayrollGroupReducedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPayrollGroupReducedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function IRenewalPayrollGroupReducedDtoToJSON(json: any): IRenewalPayrollGroupReducedDto {
    return IRenewalPayrollGroupReducedDtoToJSONTyped(json, false);
}

export function IRenewalPayrollGroupReducedDtoToJSONTyped(value?: IRenewalPayrollGroupReducedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
    };
}

